import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';

class SuccessfulReg extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    nextClicked(){
        this.props.history.push("/fooldal");
    }
    render() { 
        return ( 
            <div className="kwizda-succesfulreg-panel">
                <div>
                    <img src="img/Sikeres_regisztracio_green.png" alt="Sikeres"></img>
                </div>
                <h1>Sikeres regisztráció</h1>
                <p className="kwizda-succesfulreg-desc">Köszönjük, hogy regisztrált. 
                    Kollégáink rövidesen kiértékelik jelentkezését. 
                    A jelentkezés állapotáról emailben tájékoztatjuk, 
                    valamint bejelentkezés után az oldalunkon is ellenőrizheti.<br/>
                    <br/>
                    Értesítést a következő mail címre fogjuk továbbítani: {this.props.email}
                </p>
                <br/>
                <button className="kwizda-button" style={{width:240}}
                    onClick={()=>this.nextClicked()}>
                    Tovább az értékelési oldalra</button>
            </div>
         );
    }
}
 
export default withRouter(SuccessfulReg);